import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AESEncryptDecryptService } from './aesencrypt-decrypt.service';
import { UtilsService } from './utils.service';

@Injectable({ providedIn: 'root' })
export class GrubhubApiService {

  constructor(
    private http: HttpClient,
    private _AESEncryptDecryptService: AESEncryptDecryptService,
    private utilsService: UtilsService
  ) {}

  authenticate(code: string, orgUuid: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/grubhubApi/authenticate`, { code, orgUuid });
  }
}
